import * as React from "react";

import {
  Card,
  FormGroup,
  FormControlLabel,
  Skeleton,
  Checkbox,
} from "@mui/material";
import Typography from "@common/components/Typography";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";

export type RoomTypeInterface = {
  label: string;
  status: boolean;
  disabled?: boolean;
  key?: string;
  handleChange?: Function;
};

type RoomTypesProps = {
  roomTypes: RoomTypeInterface[];
};

const AssetCharacteristics = (
  props: React.PropsWithChildren<RoomTypesProps>
) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { detail, canEdit } = useContext(RoomsRealtimeContext);
  const { roomTypes } = props;
  const { t } = useTranslation();

  const handleOnClick = async (
    value: boolean,
    key: string,
    type: RoomTypeInterface
  ) => {
    setLoading(true);
    if (type.handleChange) {
      await type.handleChange(value, key);
    }

    setLoading(false);
  };

  return (
    <Card
      variant="outlined"
      sx={(theme) => ({
        padding: theme.spacing(2),
        "&.MuiPaper-outlined": {
          borderStyle: "dotted",
          backgroundColor: theme.palette.background.default,
        },
        "& .MuiFormControlLabel-root": {
          marginLeft: "0",
        },
      })}
    >
      <FormGroup>
        {detail?.loading || loading ? (
          <Skeleton variant="rectangular" />
        ) : (
          roomTypes?.map((type, index) => {
            return (
              <FormControlLabel
                control={<Checkbox checked={type.status} />}
                label={<Typography size="small">{t(type.label)}</Typography>}
                key={index}
                onChange={(_, checked) =>
                  handleOnClick(checked, type.key as string, type)
                }
                disabled={
                  canEdit === false ||
                  (type.disabled !== undefined ? type.disabled : false)
                }
              />
            );
          })
        )}
      </FormGroup>
    </Card>
  );
};

export default AssetCharacteristics;
